"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectMarkAsReadOption_1 = require("../actions/selectMarkAsReadOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var MarkAsReadFull = /** @class */ (function (_super) {
    tslib_1.__extends(MarkAsReadFull, _super);
    function MarkAsReadFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectMarkAsReadOption_1.default(option.key);
        };
        return _this;
    }
    MarkAsReadFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var behavior = owa_options_core_1.getFallbackValueIfNull(optionStore.behavior, userOptions.PreviewMarkAsRead);
        var delay = owa_options_core_1.getFallbackValueIfNull(optionStore.delay, userOptions.MarkAsReadDelaytime);
        var selectedKey = behavior === 'Delayed' && delay === 0 ? 'Instant' : behavior;
        var choices = [
            {
                key: 'Instant',
                text: owa_options_strings_1.default.options_mail_markAsReadInstant,
            },
            {
                key: 'Delayed',
                // TODO: VSO:13206 -Need to make a change to Fabric to allow for a dropdown inline as part of a choice
                // https://github.com/OfficeDev/office-ui-fabric-react/issues/1765
                text: owa_options_strings_1.default.options_mail_markAsReadDelayed,
            },
            {
                key: 'OnSelectionChange',
                text: owa_options_strings_1.default.options_mail_markAsReadSelectionChange,
            },
            {
                key: 'Never',
                text: owa_options_strings_1.default.options_mail_markAsReadNever,
            },
        ];
        return React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange });
    };
    MarkAsReadFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MarkAsReadFull);
    return MarkAsReadFull;
}(React.Component));
exports.default = MarkAsReadFull;
//# sourceMappingURL=MarkAsReadFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mark-as-read-option/lib/components/MarkAsReadFull.js
// module id = 5043
// module chunks = 2